// extracted by mini-css-extract-plugin
export var body = "_l1-0";
export var sectionHeader = "_l1-4";
export var shortcutColumns = "_l1-2";
export var shortcutList = "_l1-1";
export var shortcutSection = "_l1-3";